import { User } from './user';

export type Contact = Pick<User, 'userId' | 'displayName' | 'photoUrl'> & {
  contactId: string;
  phoneNumber: string;
  phoneNumbers: string[];
  emails: string[];
  createdAt: Date;
  updatedAt: Date;
};

export type DeviceContact = Omit<Contact, 'createdAt' | 'updatedAt'>;
